import apiClient from 'utilities/apiClient';

export const accountDelete = (url, payload) => {
  console.log('accountDelete', url, payload);
  return apiClient.post(`${apiClient.Urls.user_actions}/${url}`, payload, true);
};

export const accountUpdate = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.user_actions}/${url}`,
    payload,
    true
  );
};

export const accountSettings = (url, payload) => {
  console.log('accountDelete', url, payload);
  return apiClient.get(`${apiClient.Urls.user_actions}/${url}`, payload, true);
};
